import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

function getHeaders() {
  const token = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

function toError(error) {
  return {
    status: 'error',
    message: error.response?.data?.message ?? error.message,
    code: error.response?.data?.code,
    httpCode: error.response?.status
  };
}

// Mantenedor de clínicas de reembolso (124-refund-clinics-maintainer).
// Mismo contrato que el resto de src/services/: { status: 'ok', data, meta? } en éxito,
// { status: 'error', message, code, httpCode } en error.
export default class RefundClinicsService {
  // POST y no GET: la búsqueda puede ser un RUT, y los RUT no viajan en la URL.
  // orderBy: 'centerName' | 'refundsCount' | 'county'; orderDirection: 'asc' | 'desc'.
  // countryId: país de la clínica.
  static async search({ search, county, countryId, multipleRutsOnly, orderBy, orderDirection, page, pageSize }) {
    try {
      const response = await axios.post(
        `${ADMIN_URL}/refund-clinics/search`,
        {
          search: search || undefined,
          county: county || undefined,
          countryId: countryId || undefined,
          multipleRutsOnly: multipleRutsOnly || undefined,
          orderBy,
          orderDirection,
          page,
          pageSize
        },
        { headers: getHeaders() }
      );
      return { status: 'ok', data: response.data.data, meta: response.data.meta };
    } catch (error) {
      return toError(error);
    }
  }

  // payload: { centerName, businessName, county, countryId, ruts: [{ rut, previousRut? }] }, el primer RUT es el principal.
  static async update(clinicId, payload) {
    try {
      const response = await axios.put(`${ADMIN_URL}/refund-clinics/${clinicId}`, payload, {
        headers: getHeaders()
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return toError(error);
    }
  }

  // Sin mergeIntoClinicId los reembolsos quedan desvinculados (conservan nombre/RUT/comuna);
  // con él pasan a esa clínica junto con los RUT/RUC de la eliminada.
  static async remove(clinicId, mergeIntoClinicId) {
    try {
      await axios.delete(`${ADMIN_URL}/refund-clinics/${clinicId}`, {
        headers: getHeaders(),
        params: mergeIntoClinicId ? { mergeIntoClinicId } : undefined
      });
      return { status: 'ok' };
    } catch (error) {
      return toError(error);
    }
  }
}
